import React from "react";
import { useLocation } from "react-router-dom";
import WhatsAppFab from "./WhatsAppFab";

/**
 * Global WhatsApp floating button — mounted once in App.js.
 * Hidden on:
 *   - /admin/* (admin doesn't need customer WA button)
 *   - /p/:slug (ProductDetail renders its own WhatsAppFab with product-specific pre-fill)
 */
export default function GlobalWhatsAppFab() {
    const { pathname } = useLocation();
    const hidden = pathname.startsWith("/admin") || pathname.startsWith("/p/");
    if (hidden) return null;
    return <WhatsAppFab />;
}
